// Updated App.js - adding new routes
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import CategoriesPage from "./pages/CategoriesPage";
import DesignsPage from "./pages/DesignsPage";
import NewOrdersPage from "./pages/Orders/NewOrdersPage";
import OldOrdersPage from "./pages/Orders/OldOrdersPage";
import BrandsPage from "./pages/BrandsPage";
import HoldOrdersPage from "./pages/Orders/HoldOrdersPage";
import TypesPage from "./pages/TypesPage";
import BulkTypeAvailabilityPage from "./pages/BulkTypeAvailabilityPage";
import SearchOrders from "./pages/SearchOrder";
import SearchDesignPage from "./pages/SearchDesignPage";
import ChangesOrdersPage from "./pages/Orders/ChangesOrdersPage";
import ReturnsPage from "./pages/ReturnsPage";
import SpamOrdersPage from "./pages/Orders/SpamOrdersPage"; // New
import ConfirmedOrdersPage from "./pages/Orders/ConfirmedOrdersPage"; // New
import GirabatcomOrdersPage from "./pages/Orders/GirabatcomOrdersPage";
import PrintingHoldOrdersPage from "./pages/Orders/PrintingHoldOrdersPage";
import IncompleteOrdersPage from "./pages/Orders/IncompleteOrdersPage";
import PrintedOrdersPage from "./pages/Orders/PrintedOrdersPage";
import PrintletWorkflowOrdersPage from "./pages/Orders/PrintletWorkflowOrdersPage";
import TeePlusOrdersPage from "./pages/Orders/TeePlusOrdersPage";
import CustomOrdersPage from "./pages/Orders/CustomOrdersPage";
import DepositRequiredOrdersPage from "./pages/Orders/DepositRequiredOrdersPage";
import UnderPurchaseOrdersPage from "./pages/Orders/Purchase/UnderPurchaseOrdersPage"; // New
import WaitingConfirmingOrdersPage from "./pages/Orders/Purchase/WaitingConfirmingOrdersPage"; // New
import ConfirmingOrdersPage from "./pages/Orders/Purchase/ConfirmingOrdersPage"; // New
import CanceledOrdersPage from "./pages/Orders/CanceledOrdersPage"; // New
import FollowUpPhonesPage from "./pages/Orders/FollowUpPhonesPage";
import BulkWhatsAppPage from "./pages/Orders/BulkWhatsAppPage";
import BulkStatusUpdatePage from "./pages/Orders/BulkStatusUpdatePage";
import CancelledbyCustomerPage from "./pages/Orders/Purchase/CancelledbyCustomerPage";
import CouponsPage from "./pages/CouponsPage";
import CollectionsAdminPage from "./pages/CollectionsAdminPage";
import BundlesAdminPage from "./pages/BundlesAdminPage";
import BundleEditorPage from "./pages/BundleEditorPage";
import MerchandisingReportPage from "./pages/MerchandisingReportPage";
import ProductionDashboardPage from "./pages/Production/ProductionDashboardPage";
import ProductionAnalyticsPage from "./pages/Production/ProductionAnalyticsPage";
import AddToPrintQueuePage from "./pages/Production/AddToPrintQueuePage";
import AnalyticsDashboardPage from "./pages/Analytics/AnalyticsDashboardPage";
import E7seblyPage from "./pages/E7sebly/E7seblyPage";
import E7seblyInventoryPage from "./pages/E7sebly/E7seblyInventoryPage";
import FincartAnalyticsPage from "./pages/Analytics/FincartAnalyticsPage";
import CustomerAnalyticsPage from "./pages/Customers/CustomerAnalyticsPage";
import UsersManagementPage from "./pages/UsersManagementPage";
import AccessRolesPage from "./pages/AccessRolesPage";
import TicketsPage from "./pages/Tickets/TicketsPage";
import CreateTicketPage from "./pages/Tickets/CreateTicketPage";
import TicketDetailsPage from "./pages/Tickets/TicketDetailsPage";
import TicketProblemTypesPage from "./pages/Tickets/TicketProblemTypesPage";
import TicketAnalyticsPage from "./pages/Tickets/TicketAnalyticsPage";
import ReplacementOrdersPage from "./pages/Orders/ReplacementOrdersPage";
import CategoryTypesPage from "./pages/Catalog/CategoryTypesPage";
import ColorsPage from "./pages/Catalog/ColorsPage";
import PersonalizationFontsPage from "./pages/Catalog/PersonalizationFontsPage";
import CaseStylesPage from "./pages/Catalog/CaseStylesPage";
import ProductsPage from "./pages/Catalog/ProductsPage";
import ProductFormPage from "./pages/Catalog/ProductFormPage";
import PrintletLayout from "./pages/Printlet/PrintletLayout";
import PrintletOverviewPage from "./pages/Printlet/PrintletOverviewPage";
import PrintletOrdersPage from "./pages/Printlet/PrintletOrdersPage";
import PrintletOrderDetailsPage from "./pages/Printlet/PrintletOrderDetailsPage";
import PrintletMappingsPage from "./pages/Printlet/PrintletMappingsPage";
import PrintletCatalogPage from "./pages/Printlet/PrintletCatalogPage";
import PrintletEventsPage from "./pages/Printlet/PrintletEventsPage";
import PrintletFinancialsPage from "./pages/Printlet/PrintletFinancialsPage";
import PrintletSettingsPage from "./pages/Printlet/PrintletSettingsPage";
import PaymentsLayout from "./pages/Payments/PaymentsLayout";
import PaymentsOverviewPage from "./pages/Payments/PaymentsOverviewPage";
import PaymentsTransactionsPage from "./pages/Payments/PaymentsTransactionsPage";
import PaymentDetailsPage from "./pages/Payments/PaymentDetailsPage";
import KashierInfoPage from "./pages/Payments/KashierInfoPage";
import PaymentsSettingsPage from "./pages/Payments/PaymentsSettingsPage";
import NotificationCenterPage from "./pages/Notifications/NotificationCenterPage";
import OrderActivityLogPage from "./pages/Orders/OrderActivityLogPage";
import HrDashboardPage from "./pages/HR/HrDashboardPage";
import EmployeesPage from "./pages/HR/EmployeesPage";
import EmployeeProfilePage from "./pages/HR/EmployeeProfilePage";
import DepartmentsPage from "./pages/HR/DepartmentsPage";
import AttendancePage from "./pages/HR/AttendancePage";
import PerformancePage from "./pages/HR/PerformancePage";
import ReportsPage from "./pages/HR/ReportsPage";
import PayrollPage from "./pages/HR/PayrollPage";
import AdvancesPage from "./pages/HR/AdvancesPage";
import OvertimePage from "./pages/HR/OvertimePage";
import HrAnalyticsPage from "./pages/HR/HrAnalyticsPage";
import HrSettingsPage from "./pages/HR/HrSettingsPage";
import NotificationRuntime from "./Components/notifications/NotificationRuntime";

const App = () => {
  return (
    <BrowserRouter>
      <NotificationRuntime />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/users" element={<UsersManagementPage />} />
        <Route path="/access" element={<AccessRolesPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/designs" element={<DesignsPage />} />
        <Route path="/categories/:categoryId/designs" element={<DesignsPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        {/* Statues */}
        <Route path="/new-orders" element={<NewOrdersPage />} />
        <Route path="/old-orders" element={<OldOrdersPage />} />
        <Route path="/hold-orders" element={<HoldOrdersPage />} />
        <Route path="/changes-orders" element={<ChangesOrdersPage />} />
        <Route path="/spam-orders" element={<SpamOrdersPage />} /> 
        <Route path="/confirmed-orders" element={<ConfirmedOrdersPage />} />
        <Route path="/replacement-orders" element={<ReplacementOrdersPage />} /> 
        <Route path="/girabatcom-orders" element={<GirabatcomOrdersPage />} />
        <Route path="/printing-hold-orders" element={<PrintingHoldOrdersPage />} />
        <Route path="/incomplete-orders" element={<IncompleteOrdersPage />} />
        <Route path="/printed-orders" element={<PrintedOrdersPage />} />
        <Route path="/printlet-orders" element={<PrintletWorkflowOrdersPage />} />
        <Route path="/teeplus-orders" element={<TeePlusOrdersPage />} />
        <Route path="/custom-orders" element={<CustomOrdersPage />} />
        <Route path="/deposit-required-orders" element={<DepositRequiredOrdersPage />} />
        <Route path="/canceled-orders" element={<CanceledOrdersPage />} />

        {/* Purchase */}
        <Route path="/under-purchase-orders" element={<UnderPurchaseOrdersPage />} /> 
        <Route path="/waiting-confirming-orders" element={<WaitingConfirmingOrdersPage />} /> 
        <Route path="/confirming-orders" element={<ConfirmingOrdersPage />} /> 
        <Route path="/follow-up-phones" element={<FollowUpPhonesPage />} />
        <Route path="/bulk-whatsapp" element={<BulkWhatsAppPage />} />
        <Route path="/bulk-status-update" element={<BulkStatusUpdatePage />} />
        <Route path="/cancelled-by-customer-orders" element={<CancelledbyCustomerPage />} />
         {/*Types  */}
        <Route path="/brands/:brandId/types" element={<TypesPage />} />
        <Route path="/types/bulk-availability" element={<BulkTypeAvailabilityPage />} />
        <Route path="/search-orders" element={<SearchOrders />} />
        <Route path="/admin/order-activity-log" element={<OrderActivityLogPage />} />
        <Route path="/search-designs" element={<SearchDesignPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
        <Route path="/coupons" element={<CouponsPage />} />
        <Route path="/collections" element={<CollectionsAdminPage />} />
        <Route path="/bundles" element={<BundlesAdminPage />} />
        <Route path="/bundles/new" element={<BundleEditorPage />} />
        <Route path="/bundles/:id" element={<BundleEditorPage />} />
        <Route path="/merchandising" element={<MerchandisingReportPage />} />
        <Route path="/production" element={<ProductionDashboardPage />} />
        <Route path="/production/analytics" element={<ProductionAnalyticsPage />} />
        <Route path="/production/add-orders" element={<AddToPrintQueuePage />} />
        <Route path="/analytics" element={<AnalyticsDashboardPage />} />
        <Route path="/e7sebly" element={<E7seblyPage />} />
        <Route path="/e7sebly/inventory" element={<E7seblyInventoryPage />} />
        <Route path="/fincart-analytics" element={<FincartAnalyticsPage />} />
        <Route path="/customer-analytics" element={<CustomerAnalyticsPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/tickets/create" element={<CreateTicketPage />} />
        <Route path="/tickets/problem-types" element={<TicketProblemTypesPage />} />
        <Route path="/tickets/analytics" element={<TicketAnalyticsPage />} />
        <Route path="/tickets/:id" element={<TicketDetailsPage />} />
        <Route path="/admin/catalog/category-types" element={<CategoryTypesPage />} />
        <Route path="/admin/catalog/colors" element={<ColorsPage />} />
        <Route path="/admin/catalog/fonts" element={<PersonalizationFontsPage />} />
        <Route path="/admin/catalog/case-styles" element={<CaseStylesPage />} />
        <Route path="/admin/catalog/products" element={<ProductsPage />} />
        <Route path="/admin/catalog/products/new" element={<ProductFormPage />} />
        <Route path="/admin/catalog/products/:id" element={<ProductFormPage />} />
        <Route path="/printlet" element={<PrintletLayout />}>
          <Route index element={<PrintletOverviewPage />} />
          <Route path="orders" element={<PrintletOrdersPage />} />
          <Route path="orders/:id" element={<PrintletOrderDetailsPage />} />
          <Route path="mappings" element={<PrintletMappingsPage />} />
          <Route path="catalog" element={<PrintletCatalogPage />} />
          <Route path="events" element={<PrintletEventsPage />} />
          <Route path="financials" element={<PrintletFinancialsPage />} />
          <Route path="settings" element={<PrintletSettingsPage />} />
        </Route>
        <Route path="/hr" element={<HrDashboardPage />} />
        <Route path="/hr/employees" element={<EmployeesPage />} />
        <Route path="/hr/employees/:id" element={<EmployeeProfilePage />} />
        <Route path="/hr/departments" element={<DepartmentsPage />} />
        <Route path="/hr/attendance" element={<AttendancePage />} />
        <Route path="/hr/performance" element={<PerformancePage />} />
        <Route path="/hr/reports" element={<ReportsPage />} />
        <Route path="/hr/payroll" element={<PayrollPage />} />
        <Route path="/hr/advances" element={<AdvancesPage />} />
        <Route path="/hr/overtime" element={<OvertimePage />} />
        <Route path="/hr/analytics" element={<HrAnalyticsPage />} />
        <Route path="/hr/settings" element={<HrSettingsPage />} />
        <Route path="/notifications" element={<NotificationCenterPage />} />
        <Route path="/payments" element={<PaymentsLayout />}>
          <Route index element={<PaymentsOverviewPage />} />
          <Route path="transactions" element={<PaymentsTransactionsPage />} />
          <Route path="kashier" element={<KashierInfoPage />} />
          <Route path="settings" element={<PaymentsSettingsPage />} />
          <Route path=":id" element={<PaymentDetailsPage />} />
        </Route>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;